import { useId, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PrimaryButton } from 'ui/button';
import { Body2 } from 'ui/theme';
import { ModalFooter, ModalBody, ModalHeader, Modal } from 'ui/modal';
import { fetchOrganizationUsersRequest, updateOrganizationRequest } from '../actions';
import { OrganizationEditForm } from './OrganizationEditForm';
import {
  OrganizationEditFormContextType,
  OrganizationEditFormProvider,
} from '../contexts/OrganizationEditFormProvider';
import type { OrganizationEditModalModalProps, AllOrgsReduxState } from '../types';
import { selectOrganizationAsFormData } from '../selectors';

export const OrganizationEditModal = ({ orgId, onClose }: OrganizationEditModalModalProps) => {
  const id = useId();
  const editFormId = useId();
  const dispatch = useDispatch();
  const formData = useSelector((state: AllOrgsReduxState) =>
    selectOrganizationAsFormData(state, orgId),
  );

  const onSubmit = (data: OrganizationEditFormContextType) => {
    dispatch(updateOrganizationRequest(orgId, data));
    onClose();
  };

  useEffect(() => {
    dispatch(fetchOrganizationUsersRequest(orgId));
  }, [dispatch, orgId]);

  return (
    <OrganizationEditFormProvider defaultValues={formData}>
      <Modal onClose={onClose} isModalOpen id={id}>
        <ModalHeader>Edit Organization {orgId}</ModalHeader>
        <ModalBody>
          <Body2>Edit settings for an organization (Iterable employees only)</Body2>
          <OrganizationEditForm formId={editFormId} orgId={orgId} onSubmit={onSubmit} />
        </ModalBody>
        <ModalFooter onClose={onClose}>
          <PrimaryButton type="submit" form={editFormId}>
            Save organization settings
          </PrimaryButton>
        </ModalFooter>
      </Modal>
    </OrganizationEditFormProvider>
  );
};
